export const createMapping = (w: number, h: number) => ({
  marker: { x: 0, y: 0, width: w * 2, height: h * 2, mask: true },
});

export const createAnchoredMapping = (w: number, h: number, anchorX: number, anchorY: number) => ({
  marker: { x: 0, y: 0, width: w, height: h, anchorX, anchorY, mask: false },
});
